const oralSurgery = {
  hero: {
    badgeIconAlt: "Oral Surgery Icon",
    badgeText: "Precision Oral Procedures",
    titleLine1: "Advanced Oral",
    titleLine2: "Surgery Solutions",
    description:
      "Our expert oral surgeons provide precision treatments for extractions, jaw issues, and oral pathologies using state-of-the-art techniques for faster healing and optimal outcomes.",
    ctas: {
      primary: "Schedule Consultation",
      secondary: "Learn About the Process",
    },
    heroImageAlt: "Advanced Oral Surgery",
    stats: {
      successRateLabel: "Success Rate",
      successRateValue: "97%+",
      recoveryLabel: "Recovery",
      recoveryValue: "Faster",
    },
    experience: {
      label: "Surgical Excellence",
      value: "12+ Years Experience",
    },
  },
  benefits: {
    heading: "WHY CHOOSE OUR ORAL SURGERY",
    intro:
      "Experience state-of-the-art surgical procedures with optimal results and comfort.",
    items: [
      {
        title: "Precision Treatments",
        description:
          "Our surgeons utilize advanced imaging and microsurgical techniques for the highest level of precision in every procedure.",
      },
      {
        title: "Minimized Discomfort",
        description:
          "Modern anesthesia options and minimally invasive techniques ensure your comfort before, during, and after surgical procedures.",
      },
      {
        title: "Faster Recovery",
        description:
          "Our advanced approaches lead to reduced healing times, less swelling, and quicker return to normal activities.",
      },
    ],
  },
  process: {
    heading: "THE SURGICAL PROCESS",
    intro: "Our streamlined approach ensures exceptional care and outcomes.",
    steps: [
      {
        title: "Comprehensive Evaluation",
        description:
          "We begin with a thorough assessment of your oral health, medical history, and imaging to develop your customized treatment plan.",
      },
      {
        title: "Pre-Surgical Preparation",
        description:
          "We discuss anesthesia options, provide detailed pre-operative instructions, and answer all your questions to ensure you're fully prepared.",
      },
      {
        title: "Precise Surgical Procedure",
        description:
          "Using advanced techniques and technology, our surgeons perform your procedure with exceptional precision and care.",
      },
      {
        title: "Post-Operative Care",
        description:
          "We provide comprehensive aftercare instructions and follow-up to ensure optimal healing and results.",
      },
    ],
  },
  faq: {
    heading: "FREQUENTLY ASKED QUESTIONS",
    intro: "Get answers to common questions about our oral surgery procedures.",
    items: [
      {
        question: "What types of oral surgery do you perform?",
        answer:
          "We provide a comprehensive range of oral surgical procedures including wisdom teeth removal, dental implants, bone grafting, jaw surgery, biopsies, and treatment for facial trauma and infections.",
      },
      {
        question: "How do I prepare for oral surgery?",
        answer:
          "Preparation depends on your specific procedure. Generally, you should follow any fasting instructions if you're receiving sedation, arrange for transportation home, wear comfortable clothing, and follow all pre-operative instructions provided by our team.",
      },
      {
        question: "How long is the recovery process?",
        answer:
          "Recovery time varies depending on the procedure and individual healing factors. Simple extractions may only require a few days, while more complex surgeries might need 1-2 weeks for initial recovery. We'll provide specific timeline expectations for your procedure.",
      },
      {
        question: "Will my procedure be painful?",
        answer:
          "Your comfort is our priority. We use modern anesthesia techniques to ensure you don't feel pain during the procedure. Post-operative discomfort is managed with appropriate pain medication and detailed aftercare instructions.",
      },
      {
        question: "What are the risks associated with oral surgery?",
        answer:
          "While oral surgery is generally safe, all surgical procedures carry some risks, which might include infection, bleeding, nerve damage, or reactions to anesthesia. We thoroughly discuss all potential risks and take extensive precautions to minimize them.",
      },
    ],
  },
};

export default oralSurgery;

